/** The suggestions screen's sentences (S1, S2, Task 14), verbatim, in one place. */
export const DETECT_RATE_LIMITED = 'We just looked. Try again in a minute.'
export const DETECT_FAILED = "Couldn't look for recurring payments. Try again."
export const NOT_PENDING = "That suggestion isn't pending anymore."
export const NOT_AVAILABLE = "That suggestion isn't available anymore."
export const ADD_FAILED = "Couldn't add this one. Try again."
export const DISMISS_FAILED = "Couldn't dismiss it. Try again."
export const LOAD_FAILED = 'Suggestions could not be loaded.'
